module.exports = __webpack_public_path__ + "static/img/digitalSpace.327eff8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/digitalSpace.png
// module id = R33p
// module chunks = 2